import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";
import MainVisualLogo from "../../assets/images/home/main-visual-logo.png";
import FloatingKakaoIcon from "../../assets/images/home/home-floating-kakao.png";

import MainContentsImg01 from "../../assets/images/home/home-contents-img01.webp";
import MainContentsImg02 from "../../assets/images/home/home-contents-img02.webp";

import ArrowRightIcon from "../../assets/images/common/arrow-righticon.png";
import WhiteArrowRightIcon from "../../assets/images/common/white-arrow-righticon.png";

import Icon from "../../components/Icon";
import * as S from "./styled";
import FloatingBanner from "../../components/FloatingBanner";
import AOS from "aos";
import Popup from "../../components/Popup";
import Video from "../../components/Video";

import ArrowIcon from "../../assets/images/common/arrow-bottom.png";
import { Helmet } from "react-helmet-async";

const Home = () => {
  useEffect(() => {
    AOS.init();
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Helmet>
        <title>넵튠 댄스 스튜디오 | 셔플 풋워크 전문 학원</title>

        <meta
          name="description"
          content="셔플 풋워크 전문 트레이닝 센터 | 기초부터 전문인 양성까지"
        />

        <meta
          name="keywords"
          content="넵튠, 넵튠 댄스, 넵튠 댄스 스튜디오, 셔플, 셔플댄스학원, 댄스자격증, 풋워크 수업, 국제실용댄스지도자협회, 국제실용댄스, 풋워크"
        />

        <meta property="og:title" content="넵튠 댄스 스튜디오" />
        <meta
          property="og:description"
          content="셔플 풋워크 전문 트레이닝 센터 | 기초부터 전문인 양성까지"
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="http://neptunedance.com" />
        <meta
          property="og:image"
          content="http://neptunedance.com/og-image.png"
        />
      </Helmet>
      <S.HomeWrapper>
        <S.MainVideoContainer>
          <Video />
          <div className="arrow-wrap">
            <Icon>
              <img src={ArrowIcon} alt="logo" />
            </Icon>
          </div>
        </S.MainVideoContainer>
        <S.HomeMainVisualWrapper>
          <div className="inner">
            <S.HomeMainVisualContainer>
              <S.HomeMainVisualLogoWrap
                data-aos="fade-up"
                data-aos-duration={500}
                data-aos-easing="linear"
              >
                <Icon>
                  <img src={MainVisualLogo} alt="logo" />
                </Icon>
              </S.HomeMainVisualLogoWrap>
              <S.HomeMainVisualTextWrap
                data-aos="fade-left"
                data-aos-duration={700}
                data-aos-easing="linear"
              >
                <h6>
                  넵튠 댄스 스튜디오는 셔플부터
                  <br />
                  {"  "}춤을 처음 배우는 입문자를 위한 기초 프로그램과 즐거운
                  취미 클래스,
                  <br />
                  하드트레이닝 레벨부터 전문인 양성 프로그램까지
                  <br />
                  체계적인 커리큘럼과 시스템으로 구성되어 있습니다.
                </h6>
                <p>
                  또한 국제실용댄스지도자협회 IPDIA KOREA의 서울 트레이닝센터로
                  <br />
                  전문적인 강사진과 전문인 양성과정, 체계적인 교육 시스템을
                  <br />
                  만나보실 수 있습니다.
                </p>
              </S.HomeMainVisualTextWrap>
            </S.HomeMainVisualContainer>
          </div>
        </S.HomeMainVisualWrapper>

        <S.HomeMainContentWrapper>
          <div className="inner">
            <S.HomeMainContentWrap>
              <ul className="main-list">
                <li
                  data-aos="fade-up"
                  data-aos-duration={700}
                  data-aos-offset={100}
                >
                  <NavLink to="/instructors">
                    <Icon>
                      <img src={MainContentsImg01} alt="main 01 Img" />
                    </Icon>
                    <div className="info-wrap">
                      <div>
                        <h6>INSTRUCTORS</h6>
                        <p>강사진</p>
                      </div>

                      <Icon>
                        <img src={ArrowRightIcon} alt="arrow right icon" />
                      </Icon>
                    </div>
                  </NavLink>
                </li>
                <li
                  data-aos="fade-up"
                  data-aos-duration={1200}
                  data-aos-offset={100}
                >
                  <NavLink
                    to="https://www.youtube.com/@neptunedance"
                    target="_blank"
                  >
                    <Icon>
                      <img src={MainContentsImg02} alt="main 02 Img" />
                    </Icon>
                    <div className="info-wrap">
                      <div>
                        <h6>VIDEO</h6>
                        <p>수업영상</p>
                      </div>

                      <Icon>
                        <img src={ArrowRightIcon} alt="arrow right icon" />
                      </Icon>
                    </div>
                  </NavLink>
                </li>
              </ul>
              <ul
                className="introduce-list"
                data-aos="fade-up"
                data-aos-duration={1700}
                data-aos-offset={100}
              >
                <li>
                  <NavLink to="/schedule">
                    <div className="text-wrap">
                      <h6>SCHEDULE</h6>
                      <p>시간표</p>
                    </div>

                    <Icon>
                      <img src={WhiteArrowRightIcon} alt="arrow right icon" />
                    </Icon>
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/pricingClass">
                    <div className="text-wrap">
                      <h6>
                        CLASS&
                        <br />
                        PRICING
                      </h6>
                      <p>수업소개&수강료</p>
                    </div>

                    <Icon>
                      <img src={ArrowRightIcon} alt="arrow right icon" />
                    </Icon>
                  </NavLink>
                </li>
              </ul>
            </S.HomeMainContentWrap>
          </div>
        </S.HomeMainContentWrapper>

        <S.HomeBannerWrap
          data-aos="fade"
          data-aos-duration={500}
          data-aos-easing="linear"
        >
          <h6>CONTACT US</h6>
          <p>neptunedance@naver.com</p>
        </S.HomeBannerWrap>

        <FloatingBanner
          linkTo="http://pf.kakao.com/_xdxcJZn"
          icon={FloatingKakaoIcon}
          text="상담 문의"
          target="_blank"
        />

        <Popup />
      </S.HomeWrapper>
    </>
  );
};

export default Home;
